import { useMemo } from "react";

const useReturnIntroLabel = (isAboutHometownTax: boolean, isHometownTax: boolean): string => {
  return useMemo(() => {
    if (isAboutHometownTax) {
      return isHometownTax ? "返礼品紹介" : "得られるメリット";
    } else {
      return "リターン紹介";
    }
  }, [isAboutHometownTax, isHometownTax]);
};
export default useReturnIntroLabel;
